module.exports = __webpack_public_path__ + "img/map-regular.6b2ba8e9.svg";